module.exports = __webpack_public_path__ + "img/works_kuraray_miniapp_4@2x.f874174e.png";